(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.enIn = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: 'CONTACT',
      link: '/contact'
    }, {
      text: 'LOGIN',
      link: ''
    }],
    loginLink: {
      text: 'LOGIN',
      src: ''
    },
    siteLinks: [{
      title: {
        text: 'PRODUCTS'
      },
      list: [{
        text: 'Travel & Expense',
        src: '/travel-expense'
      }, {
        text: 'Expense',
        src: '/expense-management'
      }, {
        text: 'Travel',
        src: '/travel-management'
      }, {
        text: 'Invoice',
        src: '/invoice-management'
      }, {
        text: 'Intelligence',
        src: '/business-intelligence'
      }, {
        text: 'Locate',
        src: '/concur-locate'
      }]
    }, {
      title: {
        text: 'FEATURES'
      },
      list: [{
        text: 'Travel Request',
        src: '/travel-request'
      }, {
        text: 'Mobility',
        src: '/mobile-app'
      }, {
        text: 'TripLink',
        src: '/triplink'
      }, {
        text: 'Internal Compliance',
        src: '/policy-compliance'
      }, {
        text: 'Services',
        src: '/extended-services'
      }, {
        text: 'Request a Quote',
        src: '/get-quote-form',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'ABOUT US'
      },
      list: [{
        text: 'Why Concur',
        src: '/why-concur'
      }, {
        text: 'Platform',
        src: '/concur-integrated-ecosystem'
      }, {
        text: 'About SAP Concur',
        src: '/india-functionality'
      }, {
        text: 'Office Locations',
        src: '/contact/offices'
      }, {
        text: 'Corporate Social Responsibility',
        src: '/corporate-social-responsibility'
      }, {
        text: 'Contact Sales',
        src: '/contact',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'RESOURCES'
      },
      list: [{
        text: 'Newsroom',
        src: '/newsroom'
      }, {
        text: 'Resource Library',
        src: '/resource-center'
      }, {
        text: 'Case Studies',
        src: '/casestudy'
      }, {
        text: 'Events',
        src: '/events'
      }, {
        text: 'Privacy Policy',
        src: '/privacy-policy'
      }]
    }],
    supportLinks: [{
      text: 'CONCUR NEWSROOM',
      href: '/newsroom'
    }, {
      text: 'CONTACT',
      href: '/contact'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});